import React, { useMemo } from 'react'
import Actions from '../../Actions'
import ga4ReactClickHandler from 'content/src/assets/common/scripts/ga4_support/react/ga4ReactClickHandler'
import { IWeatherDisplayTemplateProps } from '../../../types'

const WeatherDisplayApricot: React.FC<IWeatherDisplayTemplateProps> = ({
  celsius,
  ariaLabel,
  ariaLiveVal,
  temperatureData,
  speedFixed,
  relativeHumidity,
  locationData,
  iconData,
  labelData,
  sourceData,
  texts,
  getActiveUnit,
  getInActiveUnit,
  setAriaLabel,
  toggleTemp,
  getActiveSpeed
}) => {
  const { temperatureFeelsLikeFixed, temperatureMaxFixed, temperatureMinFixed, temperatureFixed } =
    temperatureData

  const degrees = useMemo(
    () => (
      <div tabIndex={-1}>
        {temperatureFixed}
        <span className="tLabel active">{getActiveUnit(celsius)}</span>
        <span className="tPipe">|</span>
        <span className="tLabel">{getInActiveUnit(celsius)}</span>
      </div>
    ),
    [celsius, temperatureFixed]
  )

  return (
    <div
      className="block-main__container"
      data-mp-content-type="weather_widget"
      data-mp-share-title={`${temperatureFixed} ${getActiveUnit(celsius)}`}
      data-mp-share-description={`${locationData.cityName}, ${locationData.stateName}`}
    >
      <div className="topsection">
        <div className="leftSide">
          <button
            className="mainTemp"
            aria-label={ariaLabel}
            aria-live={ariaLiveVal}
            onFocus={() => setAriaLabel(labelData.degreesLabel)}
            onClick={() => toggleTemp(temperatureFixed, texts.click_to_switch)}
          >
            {degrees}
          </button>
          {temperatureFeelsLikeFixed && (
            <div className="feelsTemp" tabIndex={0} aria-label={labelData.feelsLikeLabel}>
              {texts.feels} {temperatureFeelsLikeFixed}&deg;
              <span className="tLabel2"></span>
            </div>
          )}
          {temperatureMaxFixed && (
            <div className="highTemp" tabIndex={0} aria-label={labelData.highTempLabel}>
              {temperatureMaxFixed}&deg; <span className="arrow">{'\u00A0'}</span>
            </div>
          )}
          {temperatureMinFixed && (
            <div className="lowTemp" tabIndex={0} aria-label={labelData.lowTempLabel}>
              {temperatureMinFixed}&deg; <span className="arrow">{'\u00A0'}</span>
            </div>
          )}
        </div>
        <div className="midSide">
          <span className="bigIcon">
            <img
              src={iconData.iconPath}
              alt={iconData.iconLabel}
              tabIndex={0}
            />
          </span>
        </div>
        <div className="rightSide">
          <div className={'place'} tabIndex={0}>
            <div>{locationData.cityName}</div>
            <div>{locationData.stateName}</div>
          </div>
          {(speedFixed || speedFixed === 0) && (
            <div className="windSpeed" tabIndex={0} aria-label={labelData.windSpeedLabel}>
              <span>
                {speedFixed}
                {getActiveSpeed()}
              </span>
              <span className="wind_icon" />
            </div>
          )}
          {relativeHumidity && (
            <div className="humidity" tabIndex={0} aria-label={labelData.humidityLabel}>
              <span className="humVal">{relativeHumidity}%</span>
              <span className="rain_icon" />
            </div>
          )}
        </div>
        <div className="btnSection">
          <a
            data-mp-cct
            title="Link to today's weather"
            href={'https://accuweather.com?sourceProviderId=dt'}
            onClick={ga4ReactClickHandler}
          >
            <div>{texts.days.today}</div>
          </a>
          <a
            data-mp-cct
            title="Link to hourly weather"
            href={'https://accuweather.com?sourceProviderId=dt'}
            onClick={ga4ReactClickHandler}
          >
            <div>{texts.days.hourly}</div>
          </a>
          <a
            data-mp-cct
            title="Link to ten day weather forecast"
            href={'https://accuweather.com?sourceProviderId=dt'}
            onClick={ga4ReactClickHandler}
          >
            <div>{texts.days.ten}</div>
          </a>
        </div>
      </div>
      <div className="partnerInfo">
        {texts.more}{' '}
        <a
          data-mp-cct
          className={'weatherLink'}
          href={'https://accuweather.com?sourceProviderId=dt'}
          onClick={ga4ReactClickHandler}
        >
          accuweather.com&reg;
        </a>
        <Actions personalize={false} />
      </div>
    </div>
  )
}

export default WeatherDisplayApricot
